import { render, staticRenderFns } from "./actionDraw.vue?vue&type=template&id=642bfffc&scoped=true&"
import script from "./actionDraw.vue?vue&type=script&lang=js&"
export * from "./actionDraw.vue?vue&type=script&lang=js&"
import style0 from "./actionDraw.vue?vue&type=style&index=0&id=642bfffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bfffc",
  null
  
)

export default component.exports